import { SVGProps, Ref, forwardRef } from 'react';

export const BackwardOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.006 4.762c1.354-.651 2.031-.977 2.513-.607.48.37.481 1.217.481 2.91v1.87l-.008 1.117c-.022.969-.112 1.515-.473 1.793l-.093.06c-.35.196-.805.074-1.524-.246l-.896-.42-1.945-.936C1.02 9.322 0 8.83 0 8c0-.832 1.02-1.322 3.06-2.303zm1.466.857c-.239.106-.515.239-.859.404l-1.946.936c-.987.474-1.613.78-2.019 1.04.406.261 1.032.567 2.019 1.042l1.946.935c.344.166.62.299.859.405l.105.044c.022-.343.023-.811.023-1.49v-1.87c0-.68-.001-1.148-.023-1.49z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.006 4.762c1.354-.651 2.031-.977 2.513-.607.48.37.481 1.217.481 2.91v1.87l-.008 1.117c-.022.969-.112 1.515-.473 1.793l-.093.06c-.35.196-.805.074-1.524-.246l-.896-.42-1.946-.936C9.02 9.322 8 8.83 8 8c0-.832 1.02-1.322 3.06-2.303zm1.466.857c-.239.106-.515.239-.859.404l-1.946.936c-.987.474-1.614.78-2.019 1.04.406.261 1.032.567 2.019 1.042l1.946.935c.344.166.62.299.859.405l.105.044c.021-.343.023-.811.023-1.49v-1.87c0-.68-.001-1.148-.023-1.49z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BackwardOutlinedSize16Glyph.displayName = 'BackwardOutlinedSize16Glyph';
